export default "__VITE_ASSET__9bhpYPw4__"